/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
import $ from "jquery";

$(document).ready(() => {
    function toggleClass(element, className) {
        element.classList.toggle(className);
    }

    function toggleMenuDisplay(e) {
        const dropdown = e.currentTarget.parentNode.parentNode;
        const menu = dropdown.querySelector('.menu');
        const icon = dropdown.querySelector('.down-arrow');

        toggleClass(menu, 'hide');
        toggleClass(icon, 'rotate-90');
    }

    function toggleMenuDisplaKeyboard(e) {
        if (e.keyCode === 13) {
            onTabEnter(e);
        }
    }

    function onTabEnter(e) {
        const dropdown = e.currentTarget.parentNode;
        const menu = dropdown.querySelector('.menu');
        const icon = dropdown.querySelector('.down-arrow');

        toggleClass(menu, 'hide');
        toggleClass(icon, 'rotate-90');
    }

    function validateButtonExist() {
        const intervalExist = setInterval(() => {
            const $categoryOption = $(".category-option");

            if ($categoryOption.length > 0) {
                $(".category-option").click(function (e) {
                    const newValue = e.target.textContent + ' ';
                    $(e.target.parentNode.parentNode).toggleClass("hide");
                    $(".dropdown .title .inner").text(newValue);
                    $(".dropdown-category .title .inner").append(`<i class="arrow down-arrow"></i>`);
                });
                clearInterval(intervalExist);
            }
        }, 100);
    }

    validateButtonExist();

    $(".sort-option").click(function (e) {
        const newValue = e.target.textContent + ' ';
        $(e.target.parentNode.parentNode).toggleClass("hide");
        $(".dropdown-sort .title .inner").text(newValue);
        $(".dropdown-sort .title .inner").append(`<i class="arrow down-arrow"></i>`);
    });

    $(".sort-option").keydown(function (e) {
        if (e.keyCode === 13) {
            const newValue = e.target.textContent + ' ';
            $(e.target.parentNode.parentNode).toggleClass("hide");
            $(".dropdown-sort .title .inner").text(newValue);
            $(".dropdown-sort .title .inner").append(`<i class="arrow down-arrow"></i>`);
        }
    });

    $(document).on("click", function (e) {
        if ($(e.target).is("span.inner") === false) {
            $(".menu.pointer-cursor").addClass("hide");
        }
    });
    
    //get elements
    const $dropdownTitleCategory = $('.dropdown .title');
    const $dropdownTitleCategorySPAN = $('.dropdown .title .inner');
    const $dropdownTitleSortByDate = $('.dropdown-sort .title');
    const $dropdownTitleSortByDateSPAN = $('.dropdown-sort .title .inner');

    //bind listeners to these elements
    if ($dropdownTitleCategory) {
        $dropdownTitleCategorySPAN.on('click', toggleMenuDisplay);
        $dropdownTitleCategory.on('keydown', toggleMenuDisplaKeyboard);
    }


    if ($dropdownTitleSortByDate) {
        $dropdownTitleSortByDateSPAN.on('click', toggleMenuDisplay);
        $dropdownTitleSortByDate.on('keydown', toggleMenuDisplaKeyboard);
    }

});